import React, { Component } from "react";

class DynamicButtonTabs extends Component {
  render() {
    const {
      tabs = [],
      activeTab,
      onTabChange,
      connected = false, // new prop
    } = this.props;

    return (
      <div
        style={{
          ...styles.container,
          gap: connected ? "0px" : "10px",
          flexWrap: connected ? "nowrap" : "wrap",
        }}
      >
        {tabs.map((tab, index) => {
          const isActive = activeTab === tab.value;
          const isFirst = index === 0;
          const isLast = index === tabs.length - 1;
          
          // Check if count exists and is greater than 0
          const hasCount = tab.hasOwnProperty('count');

          return (
            <button
              key={index}
              id={tab.id}
              onClick={() => onTabChange && onTabChange(tab)}
              style={{
                ...styles.button,

                // Connected button styles
                ...(connected
                  ? {
                      borderRadius: "0px",
                      marginLeft: index !== 0 ? "-1px" : "0px",

                      borderTopLeftRadius: isFirst ? "8px" : "0px",
                      borderBottomLeftRadius: isFirst ? "8px" : "0px",

                      borderTopRightRadius: isLast ? "8px" : "0px",
                      borderBottomRightRadius: isLast ? "8px" : "0px",
                    }
                  : {}),

                ...(isActive ? styles.activeButton : {}),
              }}
            >
              <span style={styles.labelContainer}>
                {tab.label}
                {hasCount && (
                  <span 
                    style={{
                      ...styles.countBadge,
                      ...(isActive ? styles.activeCountBadge : {})
                    }}
                  >
                    {tab.count}
                  </span>
                )}
              </span>
            </button>
          );
        })}
      </div>
    );
  }
}

const styles = {
  container: {
    display: "flex",
    gap: "10px",
    flexWrap: "wrap",
  },

  button: {
    height: "36px",
    padding: "0 18px",
    borderRadius: "8px",
    border: "1px solid #d1d5db",
    backgroundColor: "#ffffff",
    color: "#374151",
    cursor: "pointer",
    fontSize: "14px",
    fontWeight: "500",
    transition: "all 0.2s ease",
    outline: "none",
    whiteSpace: "nowrap", // optional
  },

  activeButton: {
    backgroundColor: "#2563eb",
    color: "#ffffff",
    border: "1px solid #2563eb",
    boxShadow: "0 2px 6px rgba(37, 99, 235, 0.3)",
  },

  labelContainer: {
    display: "flex",
    alignItems: "center",
    gap: "6px",
  },

  countBadge: {
    backgroundColor: "#e5e7eb",
    color: "#374151",
    padding: "1px 8px",
    borderRadius: "12px",
    fontSize: "12px",
    fontWeight: "600",
    lineHeight: "1.5",
    minWidth: "20px",
    textAlign: "center",
  },

  activeCountBadge: {
    backgroundColor: "rgba(255, 255, 255, 0.25)",
    color: "#ffffff",
  },
};

export default DynamicButtonTabs;